import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const ArrowCurvedIcon = React.memo(function ArrowCurvedIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6465 0.646477C10.8418 0.451215 11.1583 0.451215 11.3535 0.646477L13.207 2.49999L11.3535 4.35351C11.1583 4.54877 10.8418 4.54877 10.6465 4.35351C10.4512 4.15825 10.4512 3.84174 10.6465 3.64648L11.3272 2.96484C11.0351 2.99963 10.7101 3.07276 10.3819 3.21093C9.87222 3.42551 9.34362 3.80141 8.91017 4.46191C8.47409 5.12645 8.11789 6.10407 7.99806 7.54199C7.86785 9.10376 7.47401 10.2515 6.9258 11.0869C6.37494 11.9263 5.68463 12.4255 5.00685 12.7109C4.33487 12.9939 3.68623 13.0625 3.21095 13.0625C2.97217 13.0625 2.77334 13.0452 2.63185 13.0273C2.5612 13.0184 2.50454 13.0091 2.46388 13.0019C2.44374 12.9984 2.42708 12.9956 2.41506 12.9932C2.40902 12.9919 2.4033 12.991 2.39943 12.9902C2.39763 12.9898 2.39585 12.9895 2.39455 12.9893L2.39259 12.9883C2.39225 12.9882 2.39155 12.9881 2.50002 12.5L2.39162 12.9883C2.12209 12.9284 1.9519 12.6611 2.01173 12.3916C2.07163 12.1221 2.33888 11.9519 2.60841 12.0117H2.60744C2.6082 12.0119 2.60963 12.0123 2.61134 12.0127C2.61636 12.0137 2.62524 12.0154 2.63771 12.0176C2.66319 12.0221 2.70369 12.0285 2.75685 12.0351C2.86341 12.0486 3.02005 12.0625 3.21095 12.0625C3.59499 12.0625 4.10273 12.006 4.61818 11.7891C5.12781 11.5745 5.65641 11.1986 6.08986 10.5381C6.52594 9.87353 6.88214 8.89592 7.00197 7.458C7.13218 5.89623 7.52603 4.74845 8.07423 3.91308C8.62509 3.07371 9.31541 2.57448 9.99318 2.28906C10.4404 2.10075 10.8775 2.00822 11.2598 1.96679L10.6465 1.35351C10.4512 1.15825 10.4512 0.841739 10.6465 0.646477Z"
        fill={color}
      />
    </svg>
  );
});
